// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'imperial',
  heroImg: 'hero.jpg',
  heroTheme: 'dark',
  heroHeadingOne: 'IMPERIAL COLLEGE BUSINESS SCHOOL',
  heroHeadingTwo: 'INTEGRATED STUDENT PORTAL',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle'],
    },
    {
      title: 'CLIENT',
      items: ['Imperial College Business School'],
    },
    {
      title: 'PLATFORM',
      items: ['WordPress'],
    },
  ],
  heading: 'A WORDPRESS-BASED PORTAL WHICH DELIVERS ALL STUDENT LEARNING RESOURCES, COURSE INFORMATION AND ASSESSMENT UPDATES',
  challengeImg: 'challenge.png',
  challenge: ['To create an integrated portal which is the single source of communication between the Business School, faculty, and the student body.'],
  solutionImg: 'solution.png',
  solution: [
    'The Hub was developed to form the central communication platform for the entire Business School, providing information and course content, multiple forums for discussions, references and collateral for lectures, the latest work assessments and integration with a multi-stage marking tool.',
    'It also includes numerous integrations with university systems, including the student services, single sign-on and DropBox cloud storage for course material and lecture videos.  Development of the Hub included a web-based workflow system to help automate existing complex manual processes. The new platform is built on an industry-standard open source application framework.',
  ],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: 'INTERFACE OPTIMISED FOR TABLET AND MOBILE',
      content: ['EACH STUDENT IS GIVEN AN IPAD THROUGH WHICH THEY CAN ACCESS THE HUB.'],
    },
    {
      img: 'callout_2.jpg',
      title: 'NOTIFICATIONS AND COMMENTS',
      content: ['FULL WORKFLOW, INCLUDING TO-DO LISTS AND DISCUSSION BOARDS, ARE ALL AVAILABLE THROUGH THE SYSTEM.'],
    },
    {
      img: 'callout_3.jpg',
      title: 'DESIGNED TO FIT',
      content: ['EXTENSIVE ANALYSIS OF WORKFLOWS LED TO A SYSTEM THAT MEETS THE PRECISE NEEDS OF ALL USERS.'],
    },
  ],
  nextCaseStudy: 'the-order',
};

export default casestudyData;
